export var Size;
(function (Size) {
    Size["Tiny"] = "tiny";
    Size["Smallest"] = "smallest";
    Size["Smaller"] = "smaller";
    Size["Small"] = "small";
    Size["Normal"] = "normal";
    Size["Large"] = "large";
    Size["Larger"] = "larger";
    Size["Largest"] = "largest";
    Size["Huge"] = "huge";
})(Size || (Size = {}));
export var Weight;
(function (Weight) {
    Weight["Light"] = "light";
    Weight["Normal"] = "normal";
    Weight["Bold"] = "bold";
})(Weight || (Weight = {}));
export var Slope;
(function (Slope) {
    Slope["Normal"] = "normal";
    Slope["Italic"] = "italic";
})(Slope || (Slope = {}));
//# sourceMappingURL=IText.js.map